export default function FlightsCarouselController(
    $scope,
    $controller,
    flightsFactory
) {
    'ngInject';

                $controller('FlightsCarouselBaseController', {
                    $scope,
                    flightsFactory,
                });
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/controllers/flightsCarouselCtrl.js